<template>
    <el-cascader :options="options"
        :props="{ checkStrictly: true, expandTrigger: 'hover', value: 'id', label: 'name', children: 'childList' }"
        :placeholder="inputPlaceholder" clearable @change="changeOption" v-model="result" ref="cascader">
    </el-cascader>
</template>


<script>
import {
    queryDictionarySalesListByParent,
} from "@/api/SquirrelSettlement";
export default {
    data() {
        return {
            options: [],
            result: [],
        };
    },
    props: {
        inputPlaceholder: {
            type: String,
            default: "请选择故障分类"
        },
    },
    methods: {
        initOption() {
            queryDictionarySalesListByParent({ typeId: 6076 }).then(res => {
                if (res.code == 0) {
                    let list = res.data.map(item1 => {
                        item1.childList.map(item2 => {
                            item2.childList.map(item3=>{
                                delete item3.childList
                                return item3
                            })
                            return item2
                        })
                        return item1
                    })
                    this.options = list
                }
            })

        },
        changeOption(node) {
            this.$emit("changeP", this.result);
        },
        resetCascaderInput() {
            this.result = [];
        }
    },
    mounted() {
        this.initOption()
    },
};
</script>

<style lang="scss" scoped></style>